import { render, staticRenderFns } from "./menuItemGroupMenuItem.vue?vue&type=template&id=d6eb883e&lang=pug"
import script from "./menuItemGroupMenuItem.vue?vue&type=script&lang=coffee"
export * from "./menuItemGroupMenuItem.vue?vue&type=script&lang=coffee"
import style0 from "./menuItemGroupMenuItem.vue?vue&type=style&index=0&id=d6eb883e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports